import React from 'react';
import { Container } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { CurrencyRatesAdminSection } from '../../../features/stats/components/CurrencyRates/CurrencyRateAdminSection';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { isAdminOrSuperAdmin } from '../../../features/auth/helpers';
import { PageNotAllowedForUser } from '../../../features/common/components/PageNotAllowedForUser';

function CurrencyRatesAdminPage(): JSX.Element {
	const { auth } = useSelector((state: RootState) => state);
	return (
		<Layout>
			<Container component="main" maxWidth="md">
				{isAdminOrSuperAdmin(auth.user) ? <CurrencyRatesAdminSection /> : <PageNotAllowedForUser />}
			</Container>
		</Layout>
	);
}

export default CurrencyRatesAdminPage;
